module.exports = __webpack_public_path__ + "static/media/sofa.16040cef.png";